module.exports = __webpack_public_path__ + "img/Beit_Gazit.e1c17804.svg";